@if (catalogsLoading()) {
  <full-page-spinner></full-page-spinner>
} @else {
  <se-fe-page
    [seFeDataLoaded]="true"
    SeFeDataWidth="full"
    [seFeDataBackLink]="productListBackLink()"
    seFeDataBackText="Back"
    class="se-product-management product-detail create-product-page"
    id="se-product-management">
    <div seFePageHeader>
      <se-fe-header seFeDataTitle="Create product" size="750">
        <div class="create-product-header-actions" seFeHeaderActions>
          <div class="create-product-add-another" [formGroup]="pageOptionsForm">
            <se-fe-checkbox
              formControlName="addAnotherProduct"
              [seFeDataOptions]="addAnotherProductOptions"></se-fe-checkbox>
          </div>
          <se-fe-button seFeDataEmphasis="medium" (click)="onCancel()" [seFeDataIsDisabled]="cancelButtonDisabled()">
            Cancel
          </se-fe-button>
          <se-fe-button seFeDataEmphasis="high" (click)="handleSave()" [seFeDataIsDisabled]="saveButtonDisabled()">
            Save
          </se-fe-button>
        </div>
      </se-fe-header>
    </div>
    <div id="create-product-content" seFePageContent>
      @if (ready && renderFormContent) {
        <form class="create-product-form" [formGroup]="productForm" novalidate>
          <se-fe-grid seFeGridOpts="snug">
            <se-fe-grid-cell id="product-detail__wide-cards" seFeGridOpts="1/3">
              <se-fe-grid seFeGridOpts="justified">
                <se-fe-grid-cell seFeGridOpts="1/3">
                  <se-fe-card>
                    <se-fe-card-header seFeDataTitle="Product details" [seFeDataBorder]="true"></se-fe-card-header>
                    <se-fe-card-content>
                      <ng-container *ngTemplateOutlet="productDetailsFields"></ng-container>
                    </se-fe-card-content>
                  </se-fe-card>
                </se-fe-grid-cell>
              </se-fe-grid>
              <se-fe-grid seFeGridOpts="justified">
                <se-fe-grid-cell seFeGridOpts="1/3">
                  <se-fe-card>
                    <se-fe-card-header seFeDataTitle="Media" [seFeDataBorder]="true"></se-fe-card-header>
                    <se-fe-card-content>
                      <ng-container *ngTemplateOutlet="productMediaFields"></ng-container>
                    </se-fe-card-content>
                  </se-fe-card>
                </se-fe-grid-cell>
              </se-fe-grid>
              <se-fe-grid seFeGridOpts="justified">
                <se-fe-grid-cell seFeGridOpts="1/3">
                  <se-fe-card>
                    <se-fe-card-header seFeDataTitle="Variants" [seFeDataBorder]="true"></se-fe-card-header>
                    <se-fe-card-content>
                      <ng-container *ngTemplateOutlet="productVariantFields"></ng-container>
                      <ng-container *ngTemplateOutlet="productError"></ng-container>
                    </se-fe-card-content>
                  </se-fe-card>
                </se-fe-grid-cell>
              </se-fe-grid>
            </se-fe-grid-cell>
          </se-fe-grid>
        </form>
      }
    </div>
  </se-fe-page>
}

<ng-template #productDetailsFields>
  <ng-container [formGroup]="productForm">
    <se-fe-form-field class="product-form-field" [seFeDataConfig]="productNameConfig">
      <se-fe-form-field-text formControlName="productName" seFeDataAutoComplete="off"></se-fe-form-field-text>
    </se-fe-form-field>
    <se-fe-form-field class="product-form-field" [seFeDataConfig]="productPriceConfig">
      <se-fe-form-field-text
        formControlName="productPrice"
        seFeDataAutoComplete="off"
        seFeDataType="number"
        seFeDataInputMode="numeric">
        <span seFeFormFieldTextBefore>$</span>
      </se-fe-form-field-text>
    </se-fe-form-field>
    <se-fe-form-field [seFeDataConfig]="productDescLabel"></se-fe-form-field>
    @if (renderDescriptionEditor) {
      <se-fe-wysiwyg class="product-description" formControlName="description"></se-fe-wysiwyg>
    }
    @if (descriptionControl.hasError('maxlength')) {
      <span class="se-fe-wysiwyg-error">Description exceeds the maximum allowed length.</span>
    }
    <se-fe-form-field [seFeDataConfig]="brandLabel" class="product-brand">
      <se-fe-form-field-text formControlName="brand" seFeDataAutoComplete="off"></se-fe-form-field-text>
    </se-fe-form-field>
    <se-fe-form-field [seFeDataConfig]="taxCodeLabel" class="product-brand">
      <se-fe-form-field-text formControlName="taxCode" seFeDataAutoComplete="off"></se-fe-form-field-text>
    </se-fe-form-field>
    @if (catalogs().length) {
      <se-fe-form-field [seFeDataConfig]="productCatalogsLabel" class="product-brand">
        <se-fe-form-field-multiselect
          formControlName="catalogIds"
          [seFeDataOptions]="catalogOptions()"
          seFeDataPlaceholder="Select"
          seFeDataPosition="bottom"
          [seFeDataComfy]="true"></se-fe-form-field-multiselect>
      </se-fe-form-field>
    }
  </ng-container>
</ng-template>

<ng-template #productMediaFields>
  <ng-container [formGroup]="productForm">
    <se-fe-form-field [seFeDataConfig]="productImageLabel"></se-fe-form-field>
    <multi-image-upload-field
      [imagesFormArray]="productImagesFormArray"
      [parentForm]="productForm"
      [defaultAlt]="(imageDescriptionControl.value || productNameControl.value || '').trim()"
      [altValidators]="productImageAltValidators"
      [clearImagesOnManualUploaderClear]="true"
      (manualUploadCleared)="onProductImagesManualClear()"></multi-image-upload-field>
  </ng-container>
</ng-template>

<ng-template #productVariantFields>
  <ng-container [formGroup]="productForm">
    <se-fe-form-field [seFeDataConfig]="productColorLabel"></se-fe-form-field>
    <se-fe-form-field-multiselect
      id="productColorsSpec"
      formControlName="productColorsSpec"
      [seFeDataOptions]="colors"
      [seFeDataListView]="true"
      [seFeDataEnableAddNew]="true"
      [seFeDataHideSearchIcon]="true"
      [seFeDataQueryConfig]="specsValidationConfig"
      [seFeDataQueryValidators]="specsMaxLengthValidator"
      seFeDataPlaceholder="Select"
      seFeDataNotFoundMessage="Not found, press enter to add the item to the list"
      [seFeTooltipTrigger]="getColorsTooltip(colorsTooltip)"
      seFeDataPosition="bottom"
      [seFeDataReadonly]="colorsReadonly()"
      [seFeDataComfy]="true"></se-fe-form-field-multiselect>
    <se-fe-tooltip #colorsTooltip>
      You can't add any more colors because it would create more than the limit of
      {{ MAX_ALLOWED_VARIANTS }} total product variants.
    </se-fe-tooltip>
    <se-fe-form-control-help>
      Pick any colors that you offer this product in and we'll automatically create the variants for you
    </se-fe-form-control-help>
    <se-fe-form-field [seFeDataConfig]="productSizeLabel"></se-fe-form-field>
    <se-fe-form-field-multiselect
      id="productSizesSpec"
      formControlName="productSizesSpec"
      [seFeDataOptions]="sizes"
      [seFeDataListView]="true"
      [seFeDataEnableAddNew]="true"
      [seFeDataHideSearchIcon]="true"
      [seFeDataQueryConfig]="specsValidationConfig"
      [seFeDataQueryValidators]="specsMaxLengthValidator"
      seFeDataPlaceholder="Select"
      seFeDataNotFoundMessage="Not found, press enter to add the item to the list"
      [seFeTooltipTrigger]="getSizesTooltip(sizesTooltip)"
      seFeDataPosition="bottom"
      [seFeDataReadonly]="sizesReadonly()"
      [seFeDataComfy]="true"></se-fe-form-field-multiselect>
    <se-fe-tooltip #sizesTooltip>
      You can't add any more sizes because it would create more than the limit of 20 total product variants.
    </se-fe-tooltip>
    <se-fe-form-control-help>
      Pick any sizes that you offer this product in and we'll automatically create the variants for you
    </se-fe-form-control-help>
  </ng-container>
</ng-template>

<ng-template #productError>
  @if (error$ | async) {
    <se-fe-alert seFeDataType="error">
      {{ (error$ | async)?.message }}
    </se-fe-alert>
  }
</ng-template>
